<template><section><template>
<h3>Page</h3>
<div class="bs-docs-section" id="Page">
<div class="bs-example">
  <n3-page :total="100" @change="pagechange" v-model="current" :show-sizer="true" :show-elevator="true" :show-total="true"></n3-page>
  <hr>
  <n3-page :total="100" simple=""></n3-page>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-page</span> <span class="hljs-attr">:total</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"pagechange"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"current"</span>  <span class="hljs-attr">:show-sizer</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">:show-elevator</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-page</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-page</span> <span class="hljs-attr">:total</span>=<span class="hljs-string">"100"</span> <span class="hljs-attr">simple</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-page</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">current</span>: <span class="hljs-number">1</span>
    }
  },
  <span class="hljs-attr">methods</span>: {
    pagechange (page) {
      <span class="hljs-built_in">console</span>.log(page)
    }
  }
}
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>total</td>
<td><code v-pre="">Number</code></td>
<td></td>
<td>total page</td>
</tr>
<tr>
<td>current</td>
<td><code v-pre="">Number</code></td>
<td>1</td>
<td>current page</td>
</tr>
<tr>
<td>value</td>
<td><code v-pre="">Number</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>pagesize</td>
<td><code v-pre="">Number</code></td>
<td>10</td>
<td>pagesize</td>
</tr>
<tr>
<td>pagesize-opts</td>
<td><code v-pre="">Array</code></td>
<td><code v-pre="">[10, 20, 30, 40]</code></td>
<td>pagesize options</td>
</tr>
<tr>
<td>simple</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>simple type</td>
</tr>
<tr>
<td>show-total</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>show total</td>
</tr>
<tr>
<td>show-elevator</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>show elevator</td>
</tr>
<tr>
<td>show-sizer</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>show sizer</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>change</td>
<td><code v-pre="">page</code>, <code v-pre="">currentPagesize</code></td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      current: 1
    }
  },
  methods: {
    pagechange (page) {
      console.log(page)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3PageDocs.md?b8ac53b2